import React from "react";
import Header from "./components/Header";
import CareerSummary from "./components/CareerSummary";
import KeySkills from "./components/KeySkills";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar"


function App() {
  const containerStyle = {
    display: "flex",
    maxWidth: "1200px",
    margin: "20px auto",
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.6,
    color: "#333",
  };

  const contentStyle = {
    flex: 1,
    padding: "20px",
  };

  return (
    <div style={containerStyle}>
      <Sidebar /> {/* Add Sidebar component */}
      <div style={contentStyle}>
        <Header />
        <CareerSummary />
        <KeySkills />
        <Experience />
        <Footer />
      </div>
    </div>
  );
}

export default App;
